// Core shared functionality - imports and global configurations
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import Chart from "chart.js/auto";
import { _readValueToProps } from "chart.js/helpers";
import "select2";
import "select2/dist/css/select2.min.css";
import "select2/dist/js/i18n/pt-BR";
import { DotLottie } from "@lottiefiles/dotlottie-web";

// Global jQuery setup
window.$ = window.jQuery = require("jquery");
require("jquery-mask-plugin");

// Make select2 available globally
require("select2");

// Variáveis globais
window.Chart = Chart;
window.Swiper = Swiper;
window.DotLottie = DotLottie;

// Chart.js disponibilizado globalmente no core.js

// Global variables
var debounceTimeout;
let modalAberto = false;

// Export for use in other modules
export { Swiper, Chart, DotLottie, debounceTimeout, modalAberto };
